import {Component, OnInit, Inject, Input} from '@angular/core';
import {RoleService} from "../../../services/role.service";


@Component({
  selector: 'app-invoicing-nav',
  templateUrl: './invoicing-nav.component.html',
  styleUrls: ['./invoicing-nav.component.css']
})
export class InvoicingNavComponent implements OnInit {


  @Input() activeMenuItem = '';

  constructor(
      private roleService: RoleService,
  ) { }


  ngOnInit() {

  }

  currentUserIsAdmin() {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsCompliance(): boolean {
    return this.roleService.hasRoles('compliance');
  }

  currentUserIsFinance(): boolean {
    return this.roleService.hasRoles('finance');
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  currentUserIsWallet(): boolean {
    return this.roleService.hasRoles('wallet');
  }

  currentUserIsIssuerExternal(): boolean {
    return this.roleService.hasRoles(['issuer_external']);
  }
}
